import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Button, Spinner } from 'reactstrap';
import * as Icon from 'react-feather';
import FormikInput from '../ui/FormikInput';
import profesoresApiService from '../../services/http/profesoresApiService';
import funcionalidadesApiService from '../../services/http/funcionalidadesApiService';
import logger from '../../services/logger';
// 🔹 Esquema de validación
const validationSchema = Yup.object().shape({
  snombre: Yup.string().required('El nombre es obligatorio'),
  sApellidos: Yup.string().required('Los apellidos son obligatorios'),
  email2: Yup.string()
    .email('Email corporativo inválido')
    .required('El email corporativo es obligatorio'),
});

const FichaProfesor = () => {
  const [loading, setLoading] = useState(true);
  const { empresaId, profesoresId } = useParams();
  const [profesor, setProfesor] = useState(null);
  const [lmsActivo, setLmsActivo] = useState(null);
  const [creandoMoodle, setCreandoMoodle] = useState(false);

  useEffect(() => {
    const fetchProfesor = async () => {
      try {
        setLoading(true);
        const [data, lmsResponse] = await Promise.all([
          profesoresApiService.obtenerDetallesProfesor({ empresaId, profesoresId }),
          funcionalidadesApiService.obtenerLmsActivo().catch(() => ({ lms: null })),
        ]);
        data.nacimiento = data.nacimiento ? data.nacimiento.split('T')[0] : '';
        setProfesor(data);
        setLmsActivo(lmsResponse.lms || null);
      } catch (error) {
        logger.error('Error cargando profesor:', error);
        setProfesor({
          indice: profesoresId,
          snombre: '',
          sApellidos: '',
          nombre: '',
          domicilio: '',
          poblacion: '',
          provincia: '',
          Distrito: '',
          dni: '',
          nacionalidad: '',
          nacimiento: '',
          TFO1: '',
          TFO2: '',
          movil: '',
          email: '',
          email2: '',
          num_ss: '',
          id_moodle: '',
          cobserva: '',
        });
      } finally {
        setLoading(false);
      }
    };

    fetchProfesor();
  }, [empresaId, profesoresId]);

  const handleCrearEnMoodle = async () => {
    setCreandoMoodle(true);
    try {
      const result = await profesoresApiService.upsertProfesor({
        ...profesor,
        empresaId,
      });
      setProfesor((prev) => ({ ...prev, id_moodle: result.id_moodle }));
    } catch (error) {
      logger.error('Error creando profesor en Additio:', error);
    } finally {
      setCreandoMoodle(false);
    }
  };

  const handleGuardar = async (values, formikHelpers) => {
    try {
      setLoading(true);
      await profesoresApiService.upsertProfesor({
        ...values,
        empresaId,
      });
      // Recargar datos actualizados del profesor
      const updatedData = await profesoresApiService.obtenerDetallesProfesor({
        empresaId,
        profesoresId,
      });
      updatedData.nacimiento = updatedData.nacimiento ? updatedData.nacimiento.split('T')[0] : '';
      setProfesor(updatedData);
      // Resetear el formulario con los datos actualizados
      formikHelpers.resetForm({ values: updatedData });
    } catch (error) {
      logger.error('Error guardando profesor:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner color="primary" /> Cargando datos del profesor...
      </div>
    );
  }

  return (
    <>
      {profesor && (
        <Formik
          initialValues={profesor}
          onSubmit={handleGuardar}
          enableReinitialize
          validationSchema={validationSchema}
        >
          {({ isSubmitting }) => (
            <Form>
              <div className="row">
                <div className="col-md-4">
                  <FormikInput label="Código Profesor" name="indice" disabled />
                </div>
                <div className="col-md-4">
                  <FormikInput label="Nombre" name="snombre" />
                </div>
                <div className="col-md-4">
                  <FormikInput label="Apellidos" name="sApellidos" />
                </div>
              </div>

              <div className="row mt-2">
                <div className="col-md-6">
                  <FormikInput label="Nombre Completo" name="nombre" />
                </div>
                <div className="col-md-6">
                  <FormikInput label="DNI" name="dni" />
                </div>
              </div>

              <div className="row mt-2">
                <div className="col-md-6">
                  <FormikInput label="Domicilio" name="domicilio" />
                </div>
                <div className="col-md-3">
                  <FormikInput label="Población" name="poblacion" />
                </div>
                <div className="col-md-3">
                  <FormikInput label="Provincia" name="provincia" />
                </div>
              </div>

              <div className="row mt-2">
                <div className="col-md-3">
                  <FormikInput label="C. Postal" name="Distrito" />
                </div>
                <div className="col-md-3">
                  <FormikInput label="Nacionalidad" name="nacionalidad" />
                </div>
                <div className="col-md-3">
                  <FormikInput label="Fecha Nacimiento" name="nacimiento" type="date" />
                </div>
                <div className="col-md-3">
                  <FormikInput label="Nº S.Social" name="num_ss" />
                </div>
              </div>

              <div className="row mt-2">
                <div className="col-md-3">
                  <FormikInput label="Teléfono 1" name="TFO1" />
                </div>
                <div className="col-md-3">
                  <FormikInput label="Teléfono 2" name="TFO2" />
                </div>
                <div className="col-md-3">
                  <FormikInput label="Móvil" name="movil" />
                </div>
                {lmsActivo === 'moodle' && (
                  <div className="col-md-3">
                    {profesor.id_moodle ? (
                      <FormikInput label="ID Moodle" name="id_moodle" disabled />
                    ) : (
                      <div>
                        <label htmlFor="crearMoodleBtn" className="form-label">
                          <small>Additio</small>
                        </label>
                        <div>
                          <Button
                            id="crearMoodleBtn"
                            size="sm"
                            color="success"
                            onClick={handleCrearEnMoodle}
                            disabled={creandoMoodle || !profesor.email2}
                          >
                            {creandoMoodle ? <Spinner size="sm" /> : <Icon.UserPlus size={14} />}{' '}
                            Crear en Additio
                          </Button>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div className="row mt-2">
                <div className="col-md-6">
                  <FormikInput label="Email personal" name="email" type="email" />
                </div>
                <div className="col-md-6">
                  <FormikInput label="Email corporativo" name="email2" type="email" />
                </div>
              </div>

              <div className="row mt-2">
                <div className="col-12">
                  <FormikInput
                    label="Observaciones"
                    name="cobserva"
                    type="textarea"
                    placeholder="Escriba observaciones..."
                  />
                </div>
              </div>

              <div className="text-end mt-3">
                <Button color="success" type="submit" disabled={isSubmitting}>
                  Guardar
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      )}
    </>
  );
};

export default FichaProfesor;
